/**
 * Validator
 * Time
 */

import {ValidatorFn, FormGroup} from '@angular/forms';
import _toNumber from 'lodash-es/toNumber';
import _includes from 'lodash-es/includes';
import _set from 'lodash-es/set';
import _split from 'lodash-es/split';

/**
 * Check if time is correct:
 * HH:MM
 * HH < 23
 * MM < 59
 * @param {string} _path
 * @returns {ValidatorFn}
 */
export function isCorrectTime(_path: string): ValidatorFn {

    return (group: FormGroup): { [key: string]: any } => {

        let time: string = group.value;

        if (_includes(time, ":")) {
            let timeArray: string[] = _split(time, ':');
            let hour = _toNumber(timeArray[0]);
            let min = _toNumber(timeArray[1]);

            if(hour > 23 || min > 59){
                let tempObj: any = {};
                _set(tempObj, ["isIncorrectTime", 'value'], 'error');
                return tempObj;
            }else{
                return null
            }

        } else {
            return null;
        }

    };
}